<template>
  <div>
    게시판 공지사항 레이아웃
    <div>
      <button @click="$router.back()">목록</button>
      <button @click="$router.back()">저장</button>
      <button @click="$router.back()">삭제</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardWriteNoticeLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>